// RxJS
// NGRX
import { select, Store } from '@ngrx/store';

// State
import { AppState } from '../../../core/reducers';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import {
  selectInvoiceCheckReportInStore,
  selectInvoiceCheckReportPageLoading,
  selectInvoiceCheckReportShowInitWaitingMessage,
} from '../_selectors/invoice_check_report.selectors';

export class InvoiceCheckReportDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(
      select(selectInvoiceCheckReportPageLoading)
    );

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectInvoiceCheckReportShowInitWaitingMessage)
    );

    this.store
      .pipe(select(selectInvoiceCheckReportInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
